import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ConstantService, ApiService, HelperService, AuthService } from '@app/core';
import * as moment from 'moment';
declare var $: any;

@Component({
  selector: 'app-backend-sales-table',
  templateUrl: './backend-sales-table.component.html',
  styleUrls: ['./backend-sales-table.component.scss']
})
export class BackendSalesTableComponent implements OnInit {

  @Input() data: any;

  salesRecords: any = [];
  commissionHistory: any = [];
  previousMonthsCommission = 0;
  userIDMSID: any;
  role: any;
  isIndividualSale = true;
  public currentMonth: string;
  public currentYear: string;
  public salesTablePath: string;

  years: any = [];
  months: any = [];

  filterOptions = {
    month: '',
    year: ''
  };
  oTable: any;
  paidCommission: any;
  constructor(
    private apiSvc: ApiService,
    private constantSvc: ConstantService,
    private helperSvc: HelperService,
    private authenticationService: AuthService,
  ) { }

  ngOnInit() {
    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser) {
      this.userIDMSID = currentUser.userData.idms_id;
      this.role = currentUser.userData.role_id;

      if (this.role === '1') {
        this.isIndividualSale = false;
        this.salesTablePath = '/sales';
      } else {
        this.salesTablePath = '/deals';
      }
    }

    this.years = this.helperSvc.getYears();
    this.months = this.helperSvc.getMonths();
    this.currentYear = (moment().year().toString());
    this.currentMonth = ('0' + (moment().month() + 1)).slice(-2).toString();
    this.filterOptions.year = this.currentYear;
    this.filterOptions.month = this.currentMonth;
  }

  ngAfterViewInit() {
    this.loadSales();
    if (this.role !== '1') {
      this.getSalesCommissionHistory();
      this.getPreviousMonthsRemainingCommission();
    }
  }

  loadSales() {
    this.apiSvc.getService(this.constantSvc.APIConfig.GETLATESTBACKENDSALES, '?user_id=' + this.userIDMSID + '&isIndividualSales=' + this.isIndividualSale).subscribe(
      res => {
        if (res.Status === 200) {
          this.salesRecords = res.Data;
          this.initTable();
        } else {
          this.salesRecords = [];
        }
      }, err => { }
    );
  }

  getSalesCommissionHistory() {
    this.apiSvc.getService(this.constantSvc.APIConfig.GETBACKENDCOMMISSION, '?user_id=' + this.userIDMSID ).subscribe(
      res => {
        if (res.Status === 200) {
          this.commissionHistory = res.Data;
          this.paidCommission = this.commissionHistory.map(t => t.amount).reduce((acc, value) => acc + Number(value), 0);
        } else {
          this.commissionHistory = [];
        }
      }, err => console.log('error in getting sales commission ', err)
    );
  }

  getPreviousMonthsRemainingCommission() {
    this.apiSvc.getService(this.constantSvc.APIConfig.GETPREVIOUSMONTHSREMAININGBACKENDCOMM, '?user_id=' + this.userIDMSID).subscribe(
      res => {
        if (res.Status === 200) {
          this.previousMonthsCommission = res.commissionAmount;
        } else {
          this.previousMonthsCommission = 0;
        }
      }, err => console.log('error in getting sales commission ', err)
    );
  }


  getTotalCommission() {
    return this.salesRecords.map(t => t.commissionValue).reduce((acc, value) => acc + Number(value), 0);
  }

  getTotalSalesPrice() {
    return this.salesRecords.map(t => t.ContractSalesPrice).reduce((acc, value) => acc + Number(value), 0);
  }

  getRemainingCommission() {
    const total = this.salesRecords.map(t => t.commissionValue).reduce((acc, value) => acc + Number(value), 0);
    const paid = this.commissionHistory.map(t => t.amount).reduce((acc, value) => acc + Number(value), 0);
    return total - paid;
  }

  applyFilter() {
    if ($.fn.DataTable.isDataTable('#backendSalesTable')) {
      this.destroyTable();
    }
    this.loadSales();
    if (this.role !== '1') {
      this.getSalesCommissionHistory();
    }
  }

  isNA(val) {
    return val === 'N/A';
  }

  searchFilter(val) {
    const value = val ? val.trim() : '';
    this.oTable.search(value).draw();
  }

  initTable() {
    $(() => {
      this.oTable = $('#backendSalesTable').DataTable({
        'paging': true,
        'lengthChange': false,
        'searching': true,
        'ordering': false,
        'info': true,
        'autoWidth': false,
        'processing': true,
        'pageLength': 5
      });
    });
  }

  destroyTable() {
    this.oTable.clear().destroy();
  }
}
